import { render, staticRenderFns } from "./Medication.vue?vue&type=template&id=b5479090"
import script from "./Medication.vue?vue&type=script&lang=js"
export * from "./Medication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports